// Admin du skill SILAE apprenant : éditer/revert le skill, voir les corrections,
// marquer les utilisateurs de confiance. L'apprentissage reste autonome.
import { toast } from "sonner";

const ADMIN_API_BASE = `${import.meta.env.VITE_API_BASE_URL}/api/admin`;

export interface SkillVersion {
  id: string;
  version: number;
  content: string;
  isActive: boolean;
  source: "auto" | "admin";
  basedOnCorrections: number;
  createdAt: string;
}

export interface AdminCorrection {
  id: string;
  userEmail: string | null;
  trusted: boolean;
  primeName: string | null;
  generatedCode: string;
  finalCode: string;
  consumed: boolean;
  createdAt: string;
}

async function adminFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const res = await fetch(url, {
    credentials: "include",
    ...options,
    headers: { "Content-Type": "application/json", ...options.headers },
  });
  if (res.status === 401) {
    toast.error("Session administrateur expirée. Redirection en cours...");
    setTimeout(() => {
      window.location.href = "/admin";
    }, 1000);
    throw new Error("Session expirée");
  }
  return res;
}

export const aiSkillAdminService = {
  getSkill: async (): Promise<{ active: SkillVersion | null; versions: SkillVersion[] }> => {
    const res = await adminFetch(`${ADMIN_API_BASE}/learned-skill`);
    if (!res.ok) throw new Error("Échec du chargement du skill");
    const body = (await res.json()) as { active: SkillVersion | null; versions: SkillVersion[] };
    return { active: body.active, versions: body.versions };
  },

  saveSkill: async (content: string): Promise<SkillVersion> => {
    const res = await adminFetch(`${ADMIN_API_BASE}/learned-skill`, {
      method: "PUT",
      body: JSON.stringify({ content }),
    });
    if (!res.ok) throw new Error("Échec de l'enregistrement du skill");
    const body = (await res.json()) as { data: SkillVersion };
    return body.data;
  },

  revertSkill: async (id: string): Promise<SkillVersion> => {
    const res = await adminFetch(`${ADMIN_API_BASE}/learned-skill/${id}/revert`, {
      method: "POST",
    });
    if (!res.ok) throw new Error("Échec du revert");
    const body = (await res.json()) as { data: SkillVersion };
    return body.data;
  },

  listCorrections: async (
    trustedOnly = false,
  ): Promise<{ items: AdminCorrection[]; total: number }> => {
    const qs = new URLSearchParams();
    if (trustedOnly) qs.set("trustedOnly", "true");
    qs.set("limit", "100");
    const res = await adminFetch(`${ADMIN_API_BASE}/silae-corrections?${qs.toString()}`);
    if (!res.ok) throw new Error("Échec du chargement des corrections");
    const body = (await res.json()) as { data: AdminCorrection[]; total: number };
    return { items: body.data, total: body.total };
  },

  setUserTrusted: async (userId: string, trusted: boolean): Promise<void> => {
    const res = await adminFetch(`${ADMIN_API_BASE}/users/${userId}/trusted`, {
      method: "PATCH",
      body: JSON.stringify({ trusted }),
    });
    if (!res.ok) throw new Error("Échec de la mise à jour");
  },
};
